import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// styles
import colors, { focusStyles } from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { regular as regularFontWeight } from "core/fontStyles";
import breakpoints from "core/breakpoints";

const PromoStyled = styled.a`
    flex: 0 0 48%;
    @media (min-width: ${breakpoints.desktop.rem}) {
        flex: 1;
    }

    display: block;
    text-decoration: none;
    padding: ${convertPxToRem(34)} ${convertPxToRem(24)};
    border: 1px solid ${({ $borderColor }) => $borderColor};

    ${focusStyles}

    &:hover {
        border-color: ${({ $borderHoverColor }) => $borderHoverColor};
    }
`;

const Row1Styled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${convertPxToRem(16)};
`;

const HeadingStyled = styled.div`
    flex: 1;
    color: ${({ $fontColor }) => $fontColor};
    font-size: ${convertPxToRem(18)};
    line-height: 160%;
`;

const IconWrapperStyled = styled.div`
    flex: 0 0 ${convertPxToRem(44)};
    height: ${convertPxToRem(44)};
    display: flex;
    justify-content: center;
    align-items: center;
`;

const TextStyled = styled.div`
    font-size: ${convertPxToRem(13)};
    color: ${({ $fontColor }) => $fontColor};
    ${regularFontWeight};

    & > span.faux-link {
        text-decoration: underline;
        color: ${({ $linkColor }) => $linkColor};
    }
`;

// component
export const Promo = ({
    className,
    title,
    text,
    href,
    target = "_self",
    onClick,
    Icon,
    iconSize = 44,
    lightDarkProps,
}) => {
    const { linkColor, fontColor, borderColor, borderHoverColor } = lightDarkProps;

    return (
        <PromoStyled
            className={className}
            $borderColor={borderColor}
            $borderHoverColor={borderHoverColor}
            href={href}
            target={target}
            onClick={onClick}
        >
            <Row1Styled>
                <HeadingStyled $fontColor={fontColor}>{title}</HeadingStyled>
                <IconWrapperStyled>
                    <Icon
                        size={{ width: iconSize, height: iconSize }}
                        fillColor={colors.alternative.lightMode.cantaloupe}
                    />
                </IconWrapperStyled>
            </Row1Styled>
            <TextStyled
                $fontColor={fontColor}
                $linkColor={linkColor}
                dangerouslySetInnerHTML={{ __html: text }}
            />
        </PromoStyled>
    );
};

export default Promo;

// prop-types
Promo.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    target: PropTypes.string,
    iconSize: PropTypes.number,
    Icon: PropTypes.any.isRequired,
    lightDarkProps: PropTypes.object.isRequired,
};
